<template>
  <div class='threat-canvas-properties'>
    <div class='subtitle'>{{$t('ctc.tab.description')}}</div>
    <div class='description'>
      <v-textarea
        ref="descriptionTextArea"
        solo
        rows="5"
        auto-grow
        name="input-7-4"
        :label="$t('ctc.tab.description.alt')"
        :value='data.description'
        class='description__input'
        @change='propertyChanged'
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ThreatCanvasProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({type: 'canvas', description: ''}),
    },
  },
  methods: {
    propertyChanged(payload) {
      this.data.description = payload;
      this.$emit('property-changed', { ...(this.data) });
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.threat-canvas-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  .subtitle{
    color: var(--text-primary);
    font-family: $font-family-bold;
    font-size: rem(16);
    font-weight: bold;
    line-height: rem(20);
    letter-spacing: 0;
    margin-bottom: rem(10);
    margin-left: rem(10);
    margin-top: rem(10);
  }
  .description{
    margin-bottom: rem(15);
    &__input{
      margin-top: 0 !important;
      margin-left: rem(10);
      margin-right: rem(10);
    }
  }
}
</style>
